var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lb-properties"},[_c('code-mirror',{attrs:{"value":_vm.text,"options":_vm.cmOptions,"view-height":"1000px","is-scroll":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }